export default __webpack_public_path__ + "static/media/1907.370c9516.png";